import { useMemo } from "react";
import type { JSX } from "react";
import { encode } from "uqr";

/**
 * Ein QR-Code als SVG, immer auf reinem Weiß (`.qrbox`) — auch im dunklen Modus, denn
 * Kontrast für den Scanner geht vor Ästhetik (AGENTS.md, QR-Code). Die Ruhezone von
 * zwei Modulen gehört zur Komponente, nicht zum Layout.
 */
export function QrCode({ value, label, size = 208 }: { value: string; label: string; size?: number }): JSX.Element {
  const { path, modules } = useMemo(() => {
    const qr = encode(value, { ecc: "M", border: 2 });
    // Eine Pfadangabe statt hunderter Rechtecke: kleiner und schneller zu zeichnen.
    const parts: string[] = [];
    qr.data.forEach((row, y) =>
      row.forEach((dark, x) => {
        if (dark) {
          parts.push(`M${x} ${y}h1v1h-1z`);
        }
      }),
    );
    return { path: parts.join(""), modules: qr.size };
  }, [value]);

  return (
    <div className="qrbox" style={{ padding: 0 }}>
      <svg
        role="img"
        aria-label={label}
        width={size}
        height={size}
        viewBox={`0 0 ${modules} ${modules}`}
        shapeRendering="crispEdges"
      >
        <path className="qr-dark" d={path} />
      </svg>
    </div>
  );
}
